export const COUNTRY_LOCALE_MAP = {
  IN: { language: 'English', currency: 'INR' },

  AE: { language: 'Arabic', currency: 'AED' },
  SA: { language: 'Arabic', currency: 'AED' },
  QA: { language: 'Arabic', currency: 'AED' },
  KW: { language: 'Arabic', currency: 'AED' },
  OM: { language: 'Arabic', currency: 'AED' },
  BH: { language: 'Arabic', currency: 'AED' },
  EG: { language: 'Arabic', currency: 'AED' },
  JO: { language: 'Arabic', currency: 'AED' },
  IQ: { language: 'Arabic', currency: 'AED' },
  LB: { language: 'Arabic', currency: 'AED' },
  DZ: { language: 'Arabic', currency: 'AED' },
  MA: { language: 'Arabic', currency: 'AED' },
  TN: { language: 'Arabic', currency: 'AED' },

  FR: { language: 'French', currency: 'EUR' },
  BE: { language: 'French', currency: 'EUR' },
  LU: { language: 'French', currency: 'EUR' },
  MC: { language: 'French', currency: 'EUR' },

  DE: { language: 'German', currency: 'EUR' },
  AT: { language: 'German', currency: 'EUR' },

  IT: { language: 'Italian', currency: 'EUR' },
  SM: { language: 'Italian', currency: 'EUR' },
  VA: { language: 'Italian', currency: 'EUR' },

  ES: { language: 'Spanish', currency: 'EUR' },

  PT: { language: 'Portuguese', currency: 'EUR' },

  GB: { language: 'English', currency: 'GBP' },

  RU: { language: 'Russian', currency: 'RUB' },
  BY: { language: 'Russian', currency: 'RUB' },
  KZ: { language: 'Russian', currency: 'RUB' },

  CN: { language: 'Chinese', currency: 'CNY' },
  HK: { language: 'Chinese', currency: 'CNY' },
  MO: { language: 'Chinese', currency: 'CNY' },

  JP: { language: 'Japanese', currency: 'USD' },

  PH: { language: 'English', currency: 'PHP' },

  MX: { language: 'Spanish', currency: 'USD' },
  AR: { language: 'Spanish', currency: 'USD' },
  CL: { language: 'Spanish', currency: 'USD' },
  CO: { language: 'Spanish', currency: 'USD' },
  PE: { language: 'Spanish', currency: 'USD' },
  VE: { language: 'Spanish', currency: 'USD' },
  EC: { language: 'Spanish', currency: 'USD' },
  BO: { language: 'Spanish', currency: 'USD' },
  PY: { language: 'Spanish', currency: 'USD' },
  UY: { language: 'Spanish', currency: 'USD' },
  CR: { language: 'Spanish', currency: 'USD' },
  PA: { language: 'Spanish', currency: 'USD' },
  GT: { language: 'Spanish', currency: 'USD' },
  HN: { language: 'Spanish', currency: 'USD' },
  NI: { language: 'Spanish', currency: 'USD' },
  SV: { language: 'Spanish', currency: 'USD' },
  DO: { language: 'Spanish', currency: 'USD' },

  BR: { language: 'Portuguese', currency: 'USD' },

  US: { language: 'English', currency: 'USD' },
  CA: { language: 'English', currency: 'USD' },
  AU: { language: 'English', currency: 'USD' },
  NZ: { language: 'English', currency: 'USD' },

  SG: { language: 'English', currency: 'USD' },
  MY: { language: 'English', currency: 'USD' },
  TH: { language: 'English', currency: 'USD' },
  VN: { language: 'English', currency: 'USD' },
  ID: { language: 'English', currency: 'USD' },

  ZA: { language: 'English', currency: 'USD' },
  NG: { language: 'English', currency: 'USD' },
  KE: { language: 'English', currency: 'USD' },
};

export const DEFAULT_LOCALE = {
  language: 'English',
  currency: 'USD',
};
